<section>
    <div class="container-fluid banner-img d-flex justify-content-center align-items-center">
        <img class="bottomLogo" src="assets/images/white-logo.svg" alt="">
        <div class="row py-5">
            <div class="col-lg-12 col-md-12 col-sm-12 wow bounceInUp">
                <!-- form card login -->
                <div class="card login-card">
                    <div class="card-header login-header">
                        <span class="font-semi-bold">Create New Password</span><br>
                        <p class="font-regular mb-0">Create a new strong password.</p>
                    </div>
                    <div class="card-body pt-0">
                        <form class="form" [formGroup]="resetPasswordForm" autocomplete="off">
                            <div class="form-group mb-2">
                                <div class="d-flex justify-content-between align-items-center">
                                    <label class="font-medium py-2 mt-0" for="email">New Password
                                    
                                    </label>
                                    <mat-icon matTooltipPosition="right"
                                        matTooltipClass="my-tooltip"
                                        [matTooltip]="['Minimum of 8 characters','Maximum of 20 characters','At least one upper case letter','At least one lower case letter','At least one number','At least one special character'] | tooltip">info_outline</mat-icon>
                                </div>
                                <input noSpaces type="password" class="form-control font-medium input-field"
                                    formControlName="new" [ngClass]="{ 'is-invalid': submitted && f['new'].errors}"
                                    (keydown.space)="$event.preventDefault()" (paste)='$event.preventDefault()'
                                    placeholder="Enter your New Password" />
                                <div *ngIf=" submitted && f['new'].errors" class="invalid-feedback">
                                    <div *ngIf="submitted && f['new'].errors['required']">
                                        {{validationErrorMessage.newPassword}} </div>
                                </div>
                                <div *ngIf="submitted && f['new'].errors" class="invalid-feedback">
                                    <div
                                        *ngIf="submitted && (f['new'].errors['new'] || f['new'].errors['pattern'] )">
                                        {{passwordValidation(resetPasswordForm.value['new'])}}</div>
                                </div>
                            </div>
                            <div class="form-group mb-4">
                                <label class="font-medium py-2 mt-0" for="email">Confirm New Password</label>
                                <input noSpaces type="password" class="form-control font-medium input-field"
                                    formControlName="confirm"
                                    [ngClass]="{ 'is-invalid': submitted && f['confirm'].errors}"
                                    (keydown.space)="$event.preventDefault()"  (paste)='$event.preventDefault()'
                                    placeholder="Re-enter your New Password" />
                                <div *ngIf=" submitted && f['confirm'].errors" class="invalid-feedback">
                                    <div *ngIf="submitted && f['confirm'].errors['required']">
                                        {{validationErrorMessage.confirmPassword}} </div>
                                </div>
                            </div>
                            <div class="form-group mt-3">
                                <button type="submit" class="form-control submit-btn theme-button" id="btnSubmit"
                                    (click)="submitResetForm()">
                                    <span>Submit</span>
                                </button>
                                <button type="button" class="form-control mt-3 theme-button-dark" id="btnCancel"
                                    (click)="cancel()">
                                    <span>Cancel</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>